import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/login/login.vue'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

const routes = [{
		path: '',
		redirect: {
			path: '/login'
		},
	},
	{
		path: '/login',
		name: 'login',
		component: Login
	},
	{
		path: '/index',
		name: 'index',
		component: () => import('../views/index/index.vue')
	},
	{
		path: '/report',
		name: 'report',
		component: () => import('../views/editPage/index.vue')
	},
	{
		path: '/engineering_institute',
		name: 'engineering_institute',
		component: () => import('../views/editPage/engineering_institute.vue')
	},
	{
		path: '/rpropertyDetail',
		name: 'rpropertyDetail',
		component: () => import('../views/rpropertyDetail/index.vue')
	},
	{
		path: '/sdeclare',
		name: 'sdeclare',
		component: () => import('../views/sdeclare/index.vue')
	},
	{
		path: '/ypropertyDetail',
		name: 'ypropertyDetail',
		component: () => import('../views/ypropertyDetail/index.vue')
	},
	{
		path: '/qtpropertyDetail',
		name: 'qtpropertyDetail',
		component: () => import('../views/qtpropertyDetail/index.vue')
	},
	{
		path: '/declare',
		name: 'declare',
		component: () => import('../views/declare/index.vue')
	},
	{
		path: '/detailInfo',
		name: 'detailInfo',
		component: () => import('../views/detailInfo/index.vue')
	},
	{
		path: '/companyInfo',
		name: 'companyInfo',
		component: () => import('../views/companyInfo/index.vue')
	},
	{
		path: '/gdetailInfo',
		name: 'gdetailInfo',
		component: () => import('../views/gdetailInfo/index.vue')
	},
	{
		path: '/confirm',
		name: 'confirm',
		component: () => import('../views/confirm/index.vue')
	},
	{
		path: '/estimate',
		name: 'estimate',
		component: () => import('../views/estimate/index.vue')
	},
	{
		path: '/qtdetailInfo',
		name: 'qtdetailInfo',
		component: () => import('../views/qtdetailInfo/index.vue')
	},
	{
		path: '/qtgdetailInfo',
		name: 'qtgdetailInfo',
		component: () => import('../views/qtgdetailInfo/index.vue')
	},
	{
		path: '/qtconfirm',
		name: 'qtconfirm',
		component: () => import('../views/qtconfirm/index.vue')
	},
	{
		path: '/qtestimate',
		name: 'qtestimate',
		component: () => import('../views/qtestimate/index.vue')
	},
	{
		path: '/rdetailInfo',
		name: 'rdetailInfo',
		component: () => import('../views/rdetailInfo/index.vue')
	},
	{
		path: '/rgdetailInfo',
		name: 'rgdetailInfo',
		component: () => import('../views/rgdetailInfo/index.vue')
	},
	{
		path: '/rconfirm',
		name: 'rconfirm',
		component: () => import('../views/rconfirm/index.vue')
	},
	{
		path: '/restimate',
		name: 'restimate',
		component: () => import('../views/restimate/index.vue')
	},
	{
		path: '/responseDetail',
		name: 'responseDetail',
		component: () => import('../views/responseDetail/index.vue')
	},
	{
		path: '/mine',
		name: 'mine',
		component: () => import('../views/mine/index.vue')
	},
	{
		path: '/myInfo',
		name: 'myInfo',
		component: () => import('../views/myInfo/index.vue')
	},
	{
		path: '/property',
		name: 'property',
		component: () => import('../views/property/index.vue')
	},
	{
		path: '/rcapital',
		name: 'rcapital',
		component: () => import('../views/rcapital/index.vue')
	},
	{
		path: '/ycapital',
		name: 'ycapital',
		component: () => import('../views/ycapital/index.vue')
	},
	{
		path: '/ryproperty',
		name: 'ryproperty',
		component: () => import('../views/ryProperty/index.vue')
	},
	{
		path: '/rycapital',
		name: 'rycapital',
		component: () => import('../views/ryCapital/index.vue')
	},
	{
		path: '/yjcapital',
		name: 'yjcapital',
		component: () => import('../views/yjCapital/index.vue')
	},
	{
		path: '/rjcapital',
		name: 'rjcapital',
		component: () => import('../views/rjCapital/index.vue')
	},
	{
		path: '/rproperty',
		name: 'rproperty',
		component: () => import('../views/rproperty/index.vue')
	},
	{
		path: '/yproperty',
		name: 'yproperty',
		component: () => import('../views/yproperty/index.vue')
	},
	{
		path: '/yjproperty',
		name: 'yjproperty',
		component: () => import('../views/yjProperty/index.vue')
	},
	{
		path: '/rjproperty',
		name: 'rjproperty',
		component: () => import('../views/rjProperty/index.vue')
	},
	{
		path: '/rcapitalDetail',
		name: 'rcapitalDetail',
		component: () => import('../views/rcapitalDetail/index.vue')
	},
	{
		path: '/ycapitalDetail',
		name: 'ycapitalDetail',
		component: () => import('../views/ycapitalDetail/index.vue')
	},
	{
		path: '/capitalRecord',
		name: 'capitalRecord',
		component: () => import('../views/capitalRecord/index.vue')
	},
	{
		path: '/autograph',
		name: 'autograph',
		component: () => import('../views/autograph/index.vue')
	},
	{
		path: '/sign',
		name: 'sign',
		component: () => import('../views/sign/index.vue')
	},
	{
		path: '/complaint',
		name: 'complaint',
		component: () => import('../views/complaint/index.vue')
	},
	{
		path: '/noticeList',
		name: 'noticeList',
		component: () => import('../views/noticeList/index.vue')
	},
	{
		path: '/noticeDetail',
		name: 'noticeDetail',
		component: () => import('../views/noticeDetail/index.vue')
	},
	{
		path: '/consult',
		name: 'consult',
		component: () => import('../views/consult/index.vue')
	},
	{
		path: '/exchange',
		name: 'exchange',
		component: () => import('../views/exchange/index.vue')
	},
	{
		path: '/qrcode',
		name: 'qrcode',
		component: () => import('../views/qrcode/qrcode.vue')
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
